import { call, put, takeLatest } from "redux-saga/effects";
import { notification } from "antd";
import { GET, POST } from "../../api";
import ApiRouts from "../../api/routes";
import { FETCH_SINGLE_BANNER } from "../actions";
import { setBanner } from "./action";
import { setTotalCount } from "../slices/totalCountSlice";

function* fetchBannerSaga(action) {
    try {
        const response = yield call(GET, `${ApiRouts.API_SINGLE_COLLECTION}/${action.payload.collectionId}`,);
        if (response) {
            yield put(setBanner(response.data.data));
            yield put(setTotalCount(response.data.meta.total));

        } else {
            throw new Error("Failed to fetch the banner.");
        }
    } catch (error) {
        notification.error({
            message: "Banner Load Failed",
            description: error.response?.data?.message || "Something went wrong!",
            placement: "topRight",
        });
    }
}

function* singleBannerSaga() {
    yield takeLatest(FETCH_SINGLE_BANNER, fetchBannerSaga);
}


export default singleBannerSaga;
